import { COMPANY_TECH_STACK } from '../../constants/Tools';
/**
 * Converts a legacy Company Tech Stack action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertCompanyTechStackAction = inAppActionLegacy => {
  return {
    name: COMPANY_TECH_STACK,
    arguments: {
      '@type': 'map',
      value: {
        company_name: inAppActionLegacy.company_name ? {
          '@type': 'string',
          value: inAppActionLegacy.company_name
        } : undefined,
        domain: inAppActionLegacy.domain ? {
          '@type': 'string',
          value: inAppActionLegacy.domain
        } : undefined,
        intent: {
          '@type': 'string',
          value: 'company_tech'
        }
      }
    }
  };
};